$( document ).ready(function() {
    console.log( $('.js-social-buttons')  );


    $('.js-share-social').click(function(event) {
        event.preventDefault();
        console.log('clicked time to reveal', $(".js-social-buttons"));
        $(".js-social-buttons").toggleClass("js-hide-social");
    })
    
    
     $('.fb-share').click(function(e) {
        e.preventDefault();
        window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        return false;
    });

   


    
    
    
    
    console.log(window.location.pathname)



    //home page video
    
    var homeVid = $('#shopify-section-1492611835440 a ')[0];
    var mobileHomeVid = $('#shopify-section-1492611835440 a ')[1];

    var video = $('.home-video-embed');
    console.log(homeVid, mobileHomeVid);

    $(homeVid).click(function() {
        console.log('pop vid');
        $('#shopify-section-1510006088885').css('display', 'block');
        $('.icon-playvideo').trigger('click');
        $('.home-video-screenshot').css('display', 'none');
        $('.home-video-content').css('display', 'none');
        $('#shopify-section-1510006088885 .home-video').css('padding-top', '0');
        $('#shopify-section-1510006088885 .has-border').removeClass('has-border');
        
        
    })

    //  window.onclick = function(event) {
    //     if (event.target == video) {
    //         $('#shopify-section-1510006088885').css('display', 'none');
    //     }
    // }


    //wishlist code
        if (window.location.pathname === "/apps/swymWishlist/wishlist/index.php") {
            console.log('on wishlist page');
            console.log($('.page-body-content'))
            $('.page-body-content').addClass('content-area');
            $( "#swym-plugin-name" ).wrap( "<div class='page-title'></div>" );
            $( "#swym-plugin-name" ).addClass( "label" );
            $('.page-body-content.content-area').prepend( '   <div class="breadcrumb-navigation">  '  + 
                                         '       '  + 
                                         '       <span><a href="/">Home</a></span>  '  + 
                                         '         '  + 
                                         '         <span class="sep">/</span> <span>WISHLIST</span>  '  + 
                                         '         '  + 
                                         '       '  + 
                                         '  </div>  '  )
        }

    //




    //goes well with code
    

    function goesWell() {
        $('limespot-container.content-area').css('width', '100%')

        $('limespot-container.content-area h3.ls-box-title').addClass('goes-well-with-header');
        $('.ls-ul.limespot-recommendation-box-carousel-shelf').css('display', 'block');

        
        

        $('a.ls-link').addClass('my-centerer');
        $('.ls-title').css('font-weight', '300');
        $('.ls-title').css('font-size', '16px');
        //$('a.ls-link').style('text-align', 'center', 'important');




        //$('.limespot-recommendation-box-item.ls-link').addClass('my-centerer');
        
        console.log('limespot firing', $('limespot-container.content-area'));

    }

    $('h3.section-title').css('display', 'none');
    $('.sonic-related-products').css('display', 'none');
    $('.ls-add-to-cart-button').css('display', 'none');
    setTimeout(goesWell, 1000);


   




    //
  
  


    var pathString = window.location.pathname;

    var pathArray = pathString.split('/');
    console.log(pathArray, pathArray[2]);

    if (pathArray[2] === "charmed-collection") {
        console.log('case one');
      
        //       	console.log('contact',$("#product-contact"))
        
        $("#addToCart-product").removeClass("hider");
        $("#my-product-options").removeClass("hider");
        $("#my-quatity-selector").removeClass("hider");
      	$("#product-contact").addClass("hider");
        $(".product-card-details").addClass("hider");
      
      
    }    
    
    //if (pathArray[3] === "products" &&  pathArray[2] === "charmed-collection") {
      
   	 if (pathArray[3] === "products") {   
        console.log('charmed collection product page')
        $('.price').removeClass('hider');
       	$('#my-quatity-selector').removeClass('hider');
       	$('#addToCart-product').removeClass('hider');
       	$("#my-product-options").removeClass('hider');
        $('.price').css('margin-bottom', '20px');
        $('.price').css('font-size', '15px');
        //$("#product-contact").removeClass("hider");
    } else {
        console.log('case two')
        $("#product-contact").removeClass("hider");
        $('.price').addClass('hider')
    }

      
      
     
  
  
        //modal code

if($('#modalCurrentPage')) {
    $('#modalCurrentPage').val(window.location);
}   
  
    // Get the modal
var modal = document.getElementById('myModal');

// Get the button that opens the modal
var btn = document.getElementById("product-contact");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
btn.onclick = function() {
    modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
    modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
}
  
    //
});